module.exports = __webpack_public_path__ + "img/ca.ca381752.svg";